export type TableShape = 'round' | 'square' | 'rectangle'

export interface FloorTable {
  id: string // uuid generated client-side; backend may replace it later
  roomId: string
  label: string // "T1", "T2"...
  shape: TableShape
  seatCount: number // number of chairs rendered around the table
  x: number // canvas position of the bounding box top-left, in px
  y: number
  width: number // bounding box; for 'round'/'square' width === height
  height: number
  rotation: number // degrees (Konva Transformer)
}

export interface Room {
  id: string
  name: string // "Main floor", "Patio"...
  order: number
}

export interface FloorPlanData {
  rooms: Room[]
  tables: FloorTable[]
  activeRoomId: string | null
}

export const FLOOR_PLAN_SCHEMA_VERSION = 3
